/* tslint:disable */
/* eslint-disable */
/**
 * BS2
 * BoostSales 2
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateContactDto
 */
export interface CreateContactDto {
    /**
     * 
     * @type {string}
     * @memberof CreateContactDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CreateContactDto
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateContactDto
     */
    mobile?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateContactDto
     */
    _function?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateContactDto
     */
    isSigner?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof CreateContactDto
     */
    phone?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateContactDto
     */
    comment?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CreateContactDto
     */
    title: number;
    /**
     * 
     * @type {string}
     * @memberof CreateContactDto
     */
    type?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateContactDto
     */
    isCompany?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof CreateContactDto
     */
    parentId: number;
}

/**
 * Check if a given object implements the CreateContactDto interface.
 */
export function instanceOfCreateContactDto(value: object): value is CreateContactDto {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('parentId' in value) || value['parentId'] === undefined) return false;
    return true;
}

export function CreateContactDtoFromJSON(json: any): CreateContactDto {
    return CreateContactDtoFromJSONTyped(json, false);
}

export function CreateContactDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateContactDto {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'email': json['email'] == null ? undefined : json['email'],
        'mobile': json['mobile'] == null ? undefined : json['mobile'],
        '_function': json['function'] == null ? undefined : json['function'],
        'isSigner': json['is_signer'] == null ? undefined : json['is_signer'],
        'phone': json['phone'] == null ? undefined : json['phone'],
        'comment': json['comment'] == null ? undefined : json['comment'],
        'title': json['title'],
        'type': json['type'] == null ? undefined : json['type'],
        'isCompany': json['is_company'] == null ? undefined : json['is_company'],
        'parentId': json['parent_id'],
    };
}

export function CreateContactDtoToJSON(json: any): CreateContactDto {
    return CreateContactDtoToJSONTyped(json, false);
}

export function CreateContactDtoToJSONTyped(value?: CreateContactDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'email': value['email'],
        'mobile': value['mobile'],
        'function': value['_function'],
        'is_signer': value['isSigner'],
        'phone': value['phone'],
        'comment': value['comment'],
        'title': value['title'],
        'type': value['type'],
        'is_company': value['isCompany'],
        'parent_id': value['parentId'],
    };
}

